/* Olienfant: collection page. Filters (Section Rendering API), phone filter sheet with live count, "Toon alle". */
(function () {
  'use strict';
  if (customElements.get('ol-collection')) return;

  function paramsFromForm(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (String(value).trim() !== '') params.append(key, value);
    });
    return params;
  }

  class OlCollection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.baseUrl = this.dataset.baseUrl;
      this.sheet = this.querySelector('[data-filter-sheet]');
      this.sheetForm = this.sheet && this.sheet.querySelector('[data-filter-form="sheet"]');
      this.sheetBody = this.sheet && this.sheet.querySelector('[data-sheet-body]');
      this.applyButton = this.sheet && this.sheet.querySelector('[data-sheet-apply]');
      this.live = this.querySelector('[data-live]');
      this.sheetDirty = false;
      this.classList.add('is-enhanced');

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPopState = this.onPopState.bind(this);
      this.onSheetClose = this.onSheetClose.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);
      this.addEventListener('toggle', this.onToggle, true);
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('popstate', this.onPopState);
      if (this.sheet) this.sheet.addEventListener('overlay:close', this.onSheetClose);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('popstate', this.onPopState);
      if (this.sheet && !this.sheet.hidden && window.theme) theme.closeOverlay(this.sheet);
    }

    get results() { return this.querySelector('[data-collection-results]'); }

    /* ---------- Events ---------- */
    onClick(e) {
      var showAll = e.target.closest('[data-show-all]');
      if (showAll) { this.showAll(); return; }

      var opener = e.target.closest('[data-sheet-open]');
      if (opener && this.sheet) {
        opener.setAttribute('aria-expanded', 'true');
        this.sheetBody.dataset.applied = this.sheetBody.innerHTML;
        this.sheetDirty = false;
        this.applyButton.textContent = this.results.dataset.showLabel;
        theme.openOverlay(this.sheet, {
          focus: '.sheet__close',
          onClose: function () { opener.setAttribute('aria-expanded', 'false'); }
        });
        return;
      }

      if (e.target.closest('[data-sheet-clear]')) {
        this.sheetForm.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
        this.sheetForm.querySelectorAll('input[type="number"]').forEach(function (i) { i.value = ''; });
        this.sheetDirty = true;
        this.updateSheetCount();
        return;
      }

      var link = e.target.closest('a[data-filter-link]');
      if (link) {
        e.preventDefault();
        this.render(link.href, true);
      }
    }

    onChange(e) {
      var form = e.target.closest('[data-filter-form]');
      if (!form) return;
      if (form.dataset.filterForm === 'desktop') {
        if (e.target.type === 'number') return; // price: apply on submit (Enter)
        var dropdown = e.target.closest('[data-filter-dropdown]');
        this.apply(form, { reopen: dropdown && dropdown.dataset.filterDropdown, focusId: e.target.id });
      } else {
        this.sheetDirty = true;
        this.updateSheetCount();
      }
    }

    onSubmit(e) {
      var form = e.target.closest('[data-filter-form]');
      if (!form) return;
      e.preventDefault();
      if (form.dataset.filterForm === 'sheet') {
        this.sheetDirty = false;
        theme.closeOverlay(this.sheet);
      }
      this.apply(form, {});
    }

    onToggle(e) {
      var d = e.target;
      if (!d.matches || !d.matches('[data-filter-dropdown]') || !d.open) return;
      this.querySelectorAll('[data-filter-dropdown][open]').forEach(function (other) {
        if (other !== d) other.open = false;
      });
    }

    onDocClick(e) {
      if (e.target.closest('[data-filter-dropdown]')) return;
      this.closeDropdowns();
    }

    onKeydown(e) {
      if (e.key !== 'Escape') return;
      var open = this.querySelector('[data-filter-dropdown][open]');
      if (open) {
        open.open = false;
        open.querySelector('summary').focus();
      }
    }

    onPopState() {
      var url = new URL(window.location.href);
      if (url.pathname !== new URL(this.baseUrl, window.location.origin).pathname) return;
      this.render(url.toString(), false);
    }

    onSheetClose() {
      // Closed without applying: put the sheet back to the applied state.
      if (this.sheetDirty && this.sheetBody.dataset.applied != null) {
        this.sheetBody.innerHTML = this.sheetBody.dataset.applied;
      }
      this.sheetDirty = false;
      if (this.countController) this.countController.abort();
    }

    closeDropdowns() {
      this.querySelectorAll('[data-filter-dropdown][open]').forEach(function (d) { d.open = false; });
    }

    /* ---------- Grid ---------- */
    showAll() {
      var grid = this.querySelector('[data-collection-grid]');
      var more = this.querySelector('[data-collection-more]');
      if (!grid) return;
      var firstHidden = grid.children[theme.isDesktop() ? 8 : 6];
      grid.classList.remove('is-limited');
      if (more) more.hidden = true;
      if (firstHidden) {
        var link = firstHidden.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      }
    }

    /* ---------- Filtering ---------- */
    urlFor(form) {
      var params = paramsFromForm(form).toString();
      return this.baseUrl + (params ? '?' + params : '');
    }

    apply(form, options) {
      this.render(this.urlFor(form), true, options);
    }

    render(url, push, options) {
      options = options || {};
      var self = this;
      if (this.renderController) this.renderController.abort();
      this.renderController = new AbortController();
      var signal = this.renderController.signal;
      this.results.setAttribute('aria-busy', 'true');

      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', this.sectionId);
      fetch(u.toString(), { signal: signal })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-collection-results]');
          if (!fresh) throw new Error('no results');
          var current = self.results;
          current.innerHTML = fresh.innerHTML;
          current.dataset.showLabel = fresh.dataset.showLabel;
          current.dataset.count = fresh.dataset.count;
          current.removeAttribute('aria-busy');

          var freshBody = doc.querySelector('[data-sheet-body]');
          if (freshBody && self.sheetBody && !self.sheet.classList.contains('is-open')) self.sheetBody.innerHTML = freshBody.innerHTML;
          if (self.applyButton) self.applyButton.textContent = fresh.dataset.showLabel;

          var countEl = current.querySelector('[data-count-label]');
          if (self.live && countEl) self.live.textContent = countEl.dataset.countLabel;

          if (push) history.pushState({ olCollection: true }, '', url);

          if (options.reopen) {
            var d = self.querySelector('[data-filter-dropdown="' + options.reopen + '"]');
            if (d) d.open = true;
            var input = options.focusId && document.getElementById(options.focusId);
            if (input) input.focus({ preventScroll: true });
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          window.location.href = url;
        });
    }

    updateSheetCount() {
      var self = this;
      if (this.countController) this.countController.abort();
      this.countController = new AbortController();
      var u = new URL(this.urlFor(this.sheetForm), window.location.origin);
      u.searchParams.set('section_id', this.sectionId);
      this.applyButton.setAttribute('aria-busy', 'true');
      fetch(u.toString(), { signal: this.countController.signal })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-collection-results]');
          if (fresh) self.applyButton.textContent = fresh.dataset.showLabel;
          self.applyButton.removeAttribute('aria-busy');
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          self.applyButton.removeAttribute('aria-busy');
        });
    }
  }

  customElements.define('ol-collection', OlCollection);
})();
